module.exports = __webpack_public_path__ + "home-block-3-overlay-wide@2x-2Un8r6o.png";